import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Button, IconButton, Tooltip, useDisclosure } from "@chakra-ui/react"
import React, { useState } from "react"
import { FaEye, FaEyeSlash, FaTrash } from "react-icons/fa"
import PropTypes from 'prop-types'

const StatusProjectButton = props => {

    const { isOpen, onOpen, onClose } = useDisclosure()
    const [isDisabled, setIsDisabled] = useState(props.currentStatus);

    const cancelRef = React.useRef()
    return (
        <>

            {isDisabled ?
                (
                    <Tooltip label='Enable'>
                        <IconButton icon={<FaEye />} aria-label={'Enable'} size='sm' colorScheme='green' variant='outline' onClick={onOpen} />
                    </Tooltip>
                )
                :
                (
                    <Tooltip label='Disable'>
                        <IconButton icon={<FaEyeSlash />} aria-label={'Disable'} size='sm' colorScheme='orange' variant='outline' onClick={onOpen} />
                    </Tooltip>
                )}

            <AlertDialog
                isOpen={isOpen}
                leastDestructiveRef={cancelRef}
                onClose={onClose}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {isDisabled ? "Enable Project" : "Disable Project"}
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            Are you sure you want to {isDisabled ? ("enable") : ("disable")} this Project? - You will not see this project in any active searches.
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onClose}>
                                Cancel
                            </Button>
                            <Button colorScheme={isDisabled ? ("green") : ("red")} onClick={() => props.handleAction()} ml={3}>
                                {isDisabled ? ("Enable") : ("Disable")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </>
    )
}

StatusProjectButton.propTypes = {
    handleAction: PropTypes.any,
    currentStatus: PropTypes.any
}

export default StatusProjectButton